import { render, staticRenderFns } from "./ViewResellerInvoicePage.vue?vue&type=template&id=a50c82b6"
import script from "./ViewResellerInvoicePage.vue?vue&type=script&lang=js"
export * from "./ViewResellerInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports